module.exports = __webpack_public_path__ + "static/media/1.cbb32b18.svg";